import {createApp} from 'vue';
import App from './App.vue';
import '@/assets/js/styles';
import router from '@/assets/js/vue/router';
import i18n from '@/assets/js/vue/i18n';
import store from '@/assets/js/vue/vuex';
import VueSidePanel from 'vue3-side-panel';
import 'vue3-side-panel/dist/vue3-side-panel.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueGtag from "vue-gtag";

const vueApp = createApp(App);
vueApp.use(router);
vueApp.use(i18n);
vueApp.use(store);
vueApp.use(VueSidePanel);
vueApp.use(VueSweetalert2);
vueApp.use(VueGtag, {
    appName: 'Tracking BG',
    config: {
        id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
        user_id: ''
    }
}, router)

vueApp.mount('#app');
